export const PROJECTS_L = "PROJECTS_L"
export const PROJECTS_R = "PROJECTS_R"
export const PROJECTS_W = "PROJECTS_W"
export const PROJECTS_C = "PROJECTS_C"

export const PROJECTS_D = "PROJECTS_D"
export const PROJECTS_TOKENS_R = "PROJECTS_TOKENS_R"
export const PROJECTS_TOKENS_W = "PROJECTS_TOKENS_W"
export const PROJECTS_TOKENS_D = "PROJECTS_TOKENS_D"

export const COLLECTIONS_R = "COLLECTIONS_R"
export const COLLECTIONS_W = "COLLECTIONS_W"
export const COLLECTIONS_D = "COLLECTIONS_D"

export const DOCUMENTS_R = "DOCUMENTS_R"
export const DOCUMENTS_W = "DOCUMENTS_W"
export const DOCUMENTS_D = "DOCUMENTS_D"

export const USERS_L = "USERS_L"
export const USERS_R = "USERS_R"
export const USERS_W = "USERS_W"
export const USERS_D = "USERS_D"

export const APP_MONITORING_R = "APP_MONITORING_R"
export const APP_MONITORING_W = "APP_MONITORING_W"
export const APP_MONITORING_D = "APP_MONITORING_D"
export const AUDITLOGS_R = "AUDITLOGS_R"
export const INCIDENTS_R = "INCIDENTS_R"
export const INCIDENTS_W = "INCIDENTS_W"
export const INCIDENTS_D = "INCIDENTS_D"
export const TRANSACTIONAL_LOGS_R = "TRANSACTIONAL_LOGS_R"
export const TRANSACTIONAL_LOGS_W = "TRANSACTIONAL_LOGS_W"
export const WEBHOOKS_R = "WEBHOOKS_R"
export const WEBHOOKS_W = "WEBHOOKS_W"
export const WEBHOOKS_D = "WEBHOOKS_D"

export const HIGH_FREQUENCY_ALERTS_R = "HIGH_FREQUENCY_ALERTS_R"
export const HIGH_FREQUENCY_ALERTS_W = "HIGH_FREQUENCY_ALERTS_W"
export const HIGH_FREQUENCY_ALERTS_D = "HIGH_FREQUENCY_ALERTS_D"

export const SECRETS_R = "SECRETS_R"
export const SECRETS_W = "SECRETS_W"
export const SECRETS_D = "SECRETS_D"

export const DASHBOARD_R = "DASHBOARD_R"
